import type { GnomuxSequence } from "@db/content";
import { create } from "zustand";

type ConcatenateStore = {
  open: boolean;
  sequences: GnomuxSequence[];
  collectionFileId: string | undefined;
  parent: string;

  openDialog: (
    sequences: GnomuxSequence[],
    parent: string,
    collectionFileId?: string,
  ) => void;
  closeDialog: () => void;
};

export const useConcatenateStore = create<ConcatenateStore>((set) => ({
  open: false,
  sequences: [],
  collectionFileId: undefined,
  parent: "root",

  openDialog(sequences, parent, collectionFileId) {
    set({ open: true, sequences, parent, collectionFileId });
  },

  closeDialog() {
    set({
      open: false,
      sequences: [],
      collectionFileId: undefined,
      parent: "root",
    });
  },
}));
